/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "红包雨ID需要配置未开始的或者进行中的红包才会显示",
        type: "tips"
    },
    {
        name: "红包雨",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "背景图标",
                type: "img",
                memo: "建议尺寸：750px*332px"
            },
            {
                key: "ids",
                name: "红包雨场次Id",
                type: "text",
                memo: "示例:22,23,24,25",
                max: 2000
            },
            {
                key: "show_fix",
                name: "红包雨显示",
                type: "radio-box",
                "radio-list": [{
                        label: "页面内",
                        value: 1
                    },
                    {
                        label: "悬浮",
                        value: 2
                    }
                ]
            }
        ]
    }
];

export default config;